export default __webpack_public_path__ + "static/media/target.36d34b60.png";